const layerTypeSelectedReducer = (state = null, action) => {
  switch(action.type) {
    case 'LAYER_TYPE_SELECTED':
      return action.payload;
    default:
      return state
    }
  }

  export default layerTypeSelectedReducer;